<div
  class="message-tile"
  data-test="message-tile"
  [attr.data-test-id]="message.id"
  [ngClass]="{ collapsed: isCollapsed }"
>
  <div
    class="side"
    [ngClass]="{ unread: !message.isRead }"
    [attr.data-test]="'message-is-' + (message.isRead ? 'read' : 'unread')"
  ></div>

  <div class="message">
    <div class="summary" (click)="toggle()">
      <span class="date" data-test="message-date">{{
        message.created | date: 'shortDate'
      }}</span>
      <span class="title" data-test="message-title">{{ message.subject }}</span>
      <span class="text" data-test="message-text">{{ message.desc }}</span>
      <div
        *ngIf="message.body && !isCollapsed"
        [innerHTML]="message.body"
        data-test="message-body"
      ></div>
    </div>

    <div *ngIf="!isCollapsed" class="action">
      <div>
        <a
          *ngIf="message.buttonLink && message.buttonLabel"
          cignaButton="primary"
          data-test="view-claim"
          [routerLink]="[message.buttonLink]"
        >
          {{ message.buttonLabel }}
        </a>
        <button
          [disabled]="isImpersonator"
          cignaButton="link inline no-underline"
          data-test="message-details-delete"
          (click)="openDeleteDialog()"
        >
          Delete
        </button>
      </div>
      <cigna-flag
        [attr.data-test]="'flag-' + (message.flagged ? 'on' : 'off')"
        [flagged]="message.flagged"
        size="medium"
        (change)="
          updateMessages.emit({
            messageIds: [message.id],
            flagged: !message.flagged
          })
        "
      ></cigna-flag>
    </div>
  </div>

  <cigna-icon
    (click)="toggle()"
    class="toggle-icon"
    [type]="isCollapsed ? 'chevron-down' : 'chevron-up'"
  ></cigna-icon>
</div>
